import axios from 'axios'
import { stringify } from 'query-string';
import HttpError from 'custom-components/error/HttpError'

//axios.defaults.baseURL = process.env.REACT_APP_BACKEND_API_URL;



export const fetch = (url, options) => {

  const { method = 'get', data, headers, multipart, ...rest } = options;

  switch (method.toLowerCase()) {
    case 'get':
      return axios.get(url, {
        params: data,
        paramsSerializer: function(params) {
            return stringify(params, { encode: true })
        },
        ...rest 
      });
    case 'delete':
      return axios.delete(url, { data })
    case 'head':
      return axios.head(url, data)
    case 'post':
      return multipart ? axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}, ...rest}) : axios.post(url, stringify(data), {...rest})
    case 'put':
      return axios.put(url, stringify(data))
    case 'patch':
      return axios.patch(url, data)
    default:
      return axios(options)
  }
};

export function post (url, data) {
  return axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}})
}
export function postWithConfig (url, data, config) {
  return axios.post(url, data, config)
}
export function request (url, options) {
  return fetch(url, options)
           .catch(handleError)
}

function handleError (error) {
  //console.log("request.js >>> handleError!!!!!!");

  if(error.response) {

    let err = null;
    if (error.response.data && error.response.data.detailCode) {
      err = new HttpError(
        error.response.data.error,
        error.response.data.detailCode,
        error.response.data
      )
    } else {
      err = new HttpError(
        error.response.statusText,
        error.response.status,
        error.response.data
      )
    }

    return Promise.reject(err);
  } 

  return Promise.reject(error);
}

const timeouts = {};
const setTimeOut = (timeout, menu) => {
  timeouts[menu] = timeout;
}

export const poll = (url, options, time, menu) => ({
  condition: (cb) => pollingRequest (cb, url, options, time, menu),
  cancel: (menu) => pollingCancel (menu),
})

const pollingRequest = (cb, url, options, time, menu) =>
  sendRequest(url, options).then((response) => {

  let continuePolling;
  if (cb) {
    continuePolling = cb(response);
  }

  if (time && continuePolling !== false) {
    const timeOut = setTimeout(() => {
      pollingRequest(cb, url, options, time, menu);
    }, time);
    setTimeOut(timeOut, menu);
  } 

  return response;
});

const sendRequest = (url, options) => {
  // 따로 처리할 부분은 여기에 추가
  return fetch(url, options);
}

const pollingCancel = (menu) => {
  if(menu) {
    const timeout = timeouts[menu];

    if(timeout) {
        clearTimeout(timeout);
    }
  } else{
    Object.keys(this.timeouts).forEach(reqMenu => (clearTimeout(this.timeouts[reqMenu])));
  }
}